import { globalconfigRoute } from './globalconfig'

export const allGlobalconfigRoutes = [globalconfigRoute()]
